import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var El = function El(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#EL_svg__EL_svg__clip0_18052_91083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.667H0v10.666h16V2.666z",
    fill: "#0D5EAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.555h16M2.963 2.667v6.518-6.519zM0 5.629h5.926H0zm5.926-1.185H16 5.926zm0 2.37H16 5.926zM0 9.186h16H0z",
    stroke: "#fff",
    strokeWidth: 1.481
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "EL_svg__EL_svg__clip0_18052_91083"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};
export default El;